import axiosInstance from './axiosConfig';
import AsyncStorage from '@react-native-async-storage/async-storage';

// Kullanıcı profil bilgilerini al
export const getUserProfile = async () => {
  try {
    const response = await axiosInstance.get('/auth/me');
    return response.data;
  } catch (error) {
    console.error('Get profile error:', error);
    throw error;
  }
};

// Kullanıcı profil bilgilerini güncelle
export const updateUserProfile = async (profileData) => {
  try {
    const response = await axiosInstance.put('/auth/update-profile', profileData);
    return response.data;
  } catch (error) {
    console.error('Update profile error:', error);
    throw error;
  }
};

// Kullanıcı şifresini değiştir
export const changePassword = async (passwordData) => {
  try {
    const response = await axiosInstance.post('/auth/change-password', passwordData);
    return response.data;
  } catch (error) {
    console.error('Change password error:', error);
    
    // Hata yanıtını yeniden fırlat
    if (error.response) {
      throw {
        response: error.response,
        message: error.response.data.message || 'Şifre değiştirme hatası'
      };
    }
    throw error;
  }
};

// Kullanıcı hesabını sil
export const deleteUserAccount = async () => {
  try {
    const response = await axiosInstance.delete('/users/account');
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Kullanıcı bildirim ayarlarını güncelle
export const updateNotificationSettings = async (settings) => {
  try {
    const response = await axiosInstance.put('/users/notifications', settings);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Kullanıcı bildirim ayarlarını al
export const getNotificationSettings = async () => {
  try {
    const response = await axiosInstance.get('/users/notifications');
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};
